package org.multipaz.storage

class NoRecordStorageException(message: String): StorageException(message)